<template>
  <div id="app">
    <DeprecationNotice />
    <div class="app-view">
      <router-view />
    </div>
  </div>
</template>

<style lang="scss" scoped>
#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.app-view {
  flex: 1;
  min-height: 0;
}
</style>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import DeprecationNotice from '@/components/Common/DeprecationNotice.vue';

@Component({ components: { DeprecationNotice } })
export default class App extends Vue {}
</script>
